import isEmpty from 'lodash/isEmpty';

import { createContexts } from '../../utils';

import type { EventDefinition } from '../../types';

export const competitive_dashboard_action: EventDefinition = {
  getData: (_, eventData = {}) => ({
    type: eventData?.competitiveDashboard?.type,
  }),
  addContexts: ({ eventData } = {}) => {
    if (!eventData) return [];

    const { competitiveDashboard, board, boards } = eventData;

    if (competitiveDashboard?.type === 'view' && !isEmpty(boards)) {
      return boards.map(
        (board: any) =>
          createContexts(['board'], {
            eventData: {
              board: {
                id: board.id,
                idType: board.idType,
                viewOrder: board.viewOrder,
                associatedRevenue: Math.round(board.associatedRevenue || 0),
                associatedDeals: board.associatedDeals,
              },
            },
          })[0],
      );
    }

    return createContexts(['board'], {
      eventData: {
        board: {
          id: board?.id,
          idType: board?.idType,
          viewOrder: board?.viewOrder,
          associatedRevenue: Math.round(board?.associatedRevenue || 0),
          associatedDeals: board?.associatedDeals,
        },
      },
    });
  },
};
